/* START_MODULE_CONTRACT
 * PURPOSE: Группировка проектных ролей в этапы конвейера для отображения на странице ролей.
 * SCOPE: areRolesConcurrent, groupRolesIntoStages.
 * DEPENDS: M-FE-ROLES
 * LINKS: M-FE-ROLES, M-FE-TIMELINE
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * areRolesConcurrent - проверка взаимной совместимости двух ролей.
 * groupRolesIntoStages - сортировка и группировка соседних совместных ролей в этапы.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-14 - Группировка ролей по признаку «совместно» для лесенчатой вёрстки.
 * END_CHANGE_SUMMARY
 */

/* START_METHOD_areRolesConcurrent */
/* START_CONTRACT: areRolesConcurrent
 * PURPOSE: Проверить, допускают ли две роли одновременную работу над фичей.
 * INPUTS: { roleA: ProjectRole, roleB: ProjectRole }.
 * OUTPUTS: { boolean }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-ROLES, M-FE-TIMELINE
 * END_CONTRACT: areRolesConcurrent
 */
export function areRolesConcurrent(roleA, roleB) {
  if (!roleA || !roleB) {
    return false;
  }
  return Boolean(
    roleA.concurrentRoleIds?.includes(roleB.id)
    || roleB.concurrentRoleIds?.includes(roleA.id),
  );
}
/* END_METHOD_areRolesConcurrent */

/* START_METHOD_groupRolesIntoStages */
/* START_CONTRACT: groupRolesIntoStages
 * PURPOSE: Отсортировать роли по sortOrder и сгруппировать соседние совместные в этапы конвейера.
 * INPUTS: { roles: ProjectRole[] }.
 * OUTPUTS: { Array<{ index: number, roles: ProjectRole[], isConcurrent: boolean }> }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-ROLES, M-FE-TIMELINE
 * END_CONTRACT: groupRolesIntoStages
 */
export function groupRolesIntoStages(roles) {
  const sorted = [...roles].sort((a, b) => a.sortOrder - b.sortOrder);
  const stageRoles = [];

  sorted.forEach((role) => {
    const current = stageRoles[stageRoles.length - 1];
    if (current && current.every((other) => areRolesConcurrent(role, other))) {
      current.push(role);
    } else {
      stageRoles.push([role]);
    }
  });

  return stageRoles.map((rolesInStage, index) => ({
    index,
    roles: rolesInStage,
    isConcurrent: rolesInStage.length > 1,
  }));
}
/* END_METHOD_groupRolesIntoStages */
